<template>
  <div v-if="nearby.length">
    <div class="flex items-center justify-between">
      <h2 class="font-semibold text-blue dark:text-white text-2xl md:text-3xl">
        States near you
      </h2>

      <a :href="route('states.index')" class="font-semibold hover:no-underline">
        View all states
        <icon name="arrowRightLong" class="ml-2 group-hover:translate-x-1 relative transition"/>
      </a>
    </div>

    <div class="flex gap-3 lg:gap-6 pt-8 pb-6 overflow-x-auto">
      <state-card v-for="state of nearby" :key="state.code" class="min-w-72" :state="state"/>
    </div>
  </div>
</template>

<script setup>
import Icon from "@/components/Icon.vue"
import StateCard from "@/components/cards/StateCard.vue"
import ky from "ky"
import route from "ziggy-js"
import { computed, onMounted, ref } from "vue"
import { find } from "lodash-es"
import { useStates } from "@/composables/useStates"

const { states } = useStates()

const nearby = computed(() => {
  const state = find(states, { name: region.value })

  if (!state) {
    return []
  }

  return [
    state,
    ...(state.borders?.slice(0, 5) || []).map(code => find(states, { code })),
  ]
})

const region = ref(null)

onMounted(() => {
  ky.get("https://ipinfo.io/json").json().then(data => {
    if (data.country === "US") {
      region.value = data.region
    }
  })
})
</script>
